import React from 'react';

import './style.scss';

interface Props {
  className?: string;
}

const MenuDivider = React.memo<Props>(({ className = '' }) => <div className={`Menu-Divider ${className}`} />);

MenuDivider.displayName = 'MenuDivider';

export default MenuDivider;
